import type { LocationQuery } from 'vue-router';
import axiosInstance from '../../config/axios';
import type { NewOrder, Order } from '../../types/Order';
import type { APIRespPaginated } from '../../types/APIService';
import { parseOrders } from '../../utils/serverParsing';

const apiRoute = 'orders';

export async function fetchAllOrders(routeQuery: LocationQuery) {
  try {
    const res = await axiosInstance.get<APIRespPaginated<Order[]>>(apiRoute, { params: routeQuery });
    parseOrders(res.data.data.data);
    return res.data.data;
  }
  catch {
    return {
      data: [],
      total_count: 0,
      pages: 0,
    };
  }
}

export async function postOrder(order: NewOrder, ac: AbortController) {
  order.delivery_time = order.delivery_time.getTime() as any;
  if (order.address === null) {
    order.address = {} as any;
  }
  if (order.machine_type === '3d' || order.machine_type === 'models') {
    order.material_id = null as any;
    order.color = null as any;
  }
  try {
    await axiosInstance.post(`/${apiRoute}`, order, { signal: ac.signal });
    return true;
  }
  catch {
    return false;
  }
}

export async function updateOrder({ id, ...order }: Partial<Order> & { id: number }) {
  const body = { ...order };
  if (body.delivery_time) {
    body.delivery_time = body.delivery_time.getTime() as any;
  }
  try {
    await axiosInstance.patch(`/${apiRoute}/${id}`, body);
    return true;
  }
  catch {
    return false;
  }
}

export async function deleteOrder(id: number) {
  try {
    await axiosInstance.delete(`/${apiRoute}/${id}`);
    return true;
  }
  catch {
    return false;
  }
}
